import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, ArrowLeft, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage({ scope = 'tenant' }) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API}/auth/password/forgot`, { email: email.trim().toLowerCase(), scope });
        } catch {
            /* siempre 200 igual; ignorar cualquier error de red visual */
        }
        setSent(true);
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <Card className="w-full max-w-md card-aviation">
                <CardHeader>
                    <CardTitle className="font-['Barlow_Condensed'] text-2xl uppercase">Recuperar Contraseña</CardTitle>
                </CardHeader>
                <CardContent>
                    {sent ? (
                        <div className="text-center space-y-4 py-4" data-testid="forgot-success">
                            <CheckCircle className="w-12 h-12 mx-auto text-emerald-500" />
                            <p className="text-sm text-muted-foreground">
                                Si la cuenta existe, recibirás instrucciones para restablecer tu contraseña en breve. El enlace expira en 30 minutos.
                            </p>
                            <Link to={scope === 'admin' ? '/admin/login' : '/login'} className="text-primary text-sm hover:underline inline-flex items-center gap-1">
                                <ArrowLeft className="w-3 h-3" /> Volver al login
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={submit} className="space-y-4">
                            <p className="text-sm text-muted-foreground">Ingresa tu correo. Te enviaremos un enlace para restablecer tu contraseña.</p>
                            <div className="space-y-2">
                                <Label htmlFor="fp-email">Correo electrónico</Label>
                                <Input id="fp-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} data-testid="forgot-email" />
                            </div>
                            <Button type="submit" className="w-full btn-primary" disabled={loading || !email} data-testid="forgot-submit">
                                {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
                                Enviar enlace
                            </Button>
                            <Link to={scope === 'admin' ? '/admin/login' : '/login'} className="text-xs text-muted-foreground hover:text-primary inline-flex items-center gap-1">
                                <ArrowLeft className="w-3 h-3" /> Cancelar
                            </Link>
                        </form>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}
